module.exports = {
      id: "play-games-usage",
      viewBox: "0 0 529 386",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#play-games",
      toString: function () {
        return this.url;
      }
    }